import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6cd9f099"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer view-container"
};
const _hoisted_2 = {
  class: "topBox"
};
const _hoisted_3 = {
  class: "view-content"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "qrcodeWrap"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信扫码关注", -1));
const _hoisted_8 = {
  class: "bottomBox"
};
const _hoisted_9 = {
  class: "view-content"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copyright ©2025 康信通健康科技（深圳）有限公司", -1));
const _hoisted_11 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
const _hoisted_12 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.OPTIONS, (ul, i) => {
    return _openBlock(), _createElementBlock("ul", {
      key: i
    }, [_createElementVNode("li", _hoisted_4, _toDisplayString(ul.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ul.items, (item, j) => {
      return _openBlock(), _createElementBlock("li", {
        key: j
      }, [_createVNode(_component_router_link, {
        to: item.path
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
        _: 2
      }, 1032, ["to"])]);
    }), 128))]);
  }), 128)), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $data.qrcodeImg,
    width: "120",
    height: "120"
  }, null, 8, _hoisted_6), _hoisted_7])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, [_hoisted_10, _createElementVNode("a", _hoisted_11, [_createElementVNode("img", {
    src: $data.badgeUrl,
    width: "20",
    height: "20"
  }, null, 8, _hoisted_12), _createTextVNode("粤ICP备2024335777号")])])])])]);
}